import React from 'react';
import ReactQuill, { Quill } from 'react-quill'
import ImageResize from 'quill-image-resize-module-react'
import { Input, Label, FormGroup, Form, Alert, Button, ButtonGroup, UncontrolledTooltip } from 'reactstrap';
import '../assets/css/quill.inscribe.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../assets/css/global.css';
import FilterControl from "react-filter-control";
import CloseIcon from "@mui/icons-material/Close"
import EditIcon from "@mui/icons-material/Edit"
import CheckIcon from "@mui/icons-material/Done"
import { Popover } from '@mui/material';
import { QuillParameterUrlPopover } from './popovers/QuillParameterURLPopover';
import { TemplateDeleteConfirmPopover } from './popovers/TemplateDeleteConfirmPopover';

Quill.register('modules/ImageResize', ImageResize);

var Parchment = Quill.import('parchment');
var dataId = new Parchment.Attributor.Attribute('data-id', 'data-id', {
  scope: Parchment.Scope.BLOCK
});
Quill.register(dataId);

// need to set quill values as globals when quill focus is lost
let quill = null;
let last_index = 0;

/*
 * Custom "star" icon for the toolbar using an Octicon
 * https://octicons.github.io
 */
const CustomHtmlButton = () => <span className="inscribe s-fonticon-btn"></span>

const CustomSagePayButton = () => <span className="inscribe s-fonticon-btn">$</span>

const CustomURLButton = () => <span className="inscribe s-fonticon-btn">P</span>

function insertCustomTags(value) {
  const cursorPosition = this.quill.getSelection().index
  if(typeof value === 'string')
    {
      this.quill.insertText(cursorPosition, value)
      this.quill.setSelection(cursorPosition + value.length)
    }
}

function insertPayItNow() {

  var _this3 = this; //assocaite this to a variable so we can access it in the chaneg event beloow

  var fileInput = this.container.querySelector('input.ql-image[type=file]');
  if (fileInput == null) {
    //alert('Yes mate');
    var fileInput = document.createElement('input');
    fileInput.setAttribute('type', 'file');
    fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
    fileInput.classList.add('ql-image');
    fileInput.addEventListener('change', function () {
      if (fileInput.files != null && fileInput.files[0] != null) {
        const cursorPosition = _this3.quill.getSelection().index;
        var reader = new FileReader();
        reader.onload = function (e) {
          var str2 = "<p><a href='INEEDTOBEREPLACEDWITHASAGEPAYURL'><img src='" + reader.result + "' alt='Pay it now!' style='width:42px;height:42px;border:0'></a></p>";
          //TODO: consider if a user wanted to add more than one Sage Pay It now button .... do we need to add an incrementing number to the alt tag.
          //_this3.quill.clipboard.dangerouslyPasteHTML(cursorPosition, '&nbsp;<p><img  alt="sagePayImage" src="' + reader.result +'" alt="sagePayImage" width="109"></p>');
          _this3.quill.clipboard.dangerouslyPasteHTML(cursorPosition, str2);
        };

        reader.readAsDataURL(fileInput.files[0]);
        fileInput.value = "";
      }
    });
    this.container.appendChild(fileInput);
    fileInput.click();
  }
  else {
    fileInput.click();
  }

}

function insertParamertisedURL(value) {
  if (typeof (value) == 'boolean') {
    quill = this.quill;
    last_index = quill.getSelection().index;
    return
  }

  quill.clipboard.dangerouslyPasteHTML(last_index, value);
  quill.setSelection(last_index + value.length);

  quill = null;
  last_index = last_index + value.length;
}

const generateDefaultFilter = (reportFields = []) => {
  if (reportFields.length === 0) return { groupName: 'and', items: [] };

  return {
    groupName: 'and',
    items: [
      {
        field: reportFields[0].Name,
        operator: '=',
        value: ''
      }
    ]
  };
};

const defaultFieldDescriptions = {
  BPNAME: "BP Name",
  BPNUMBER: "BP Number",
  BPCNUMBER: "BPC Number",
  BPSNUMBER: "BPS Number",
  Company: "Company",
  Currency: "Currency",
  Description: "Description",
  DocumentID: "Document Ref",
  DocumentType: "Document Type",
  Pages: "Pages",
  OrderRef: "Order Ref",
  TransactionDate: "Transaction Date",
  TransactionNumber: "Transaction Number",
  TransactionType: "Transaction Type",
  TransactionValue: "Transaction Value",
  UserName: "User Name",
  DocumentStatus: "DocumentStatus",
  IsPriority: "IsPriority"
};

const defaultOperators = [
  { name: "=", caption: "Equals" },
  { name: "<>", caption: "Does not equal" },
  { name: ">", caption: "Greater than" },
  { name: "<", caption: "Less than" },
  { name: "contains", caption: "Contains" },
  { name: "doesNotContain", caption: "Does Not Contain" }
];


const CustomToolbar = ({ onClickParameterURL, onClickSagePay, onClickHtml, onClickAddFilter, onClickAddRemoveFilter, customFields }) => (
  <div id="toolbar">
    <select className="ql-header" defaultValue={""} onChange={e => e.persist()}>
      <option value="1"></option>
      <option value="2"></option>
      <option value="3"></option>
      <option value="4"></option>
      <option selected></option>
    </select>
    <select className="ql-font">
      <option value="serif"></option>
      <option value="monospace"></option>
      <option selected></option>
    </select>
    <button className="ql-bold" id="bold"></button>
    <UncontrolledTooltip placement="bottom" target="bold">
      Bold
    </UncontrolledTooltip>
    <button className="ql-italic" id="italic"></button>
    <UncontrolledTooltip placement="bottom" target="italic">
      Italic
    </UncontrolledTooltip>
    <button className="ql-underline" id="underline"></button>
    <UncontrolledTooltip placement="bottom" target="underline">
      Underline
    </UncontrolledTooltip>
    <button className="ql-strike" id="strike"></button>
    <UncontrolledTooltip placement="bottom" target="strike">
      Strikethrough
    </UncontrolledTooltip>
    <button className="ql-list" value="ordered" id="ordered"></button>
    <UncontrolledTooltip placement="bottom" target="ordered">
      Number list
    </UncontrolledTooltip>
    <button className="ql-list" value="bullet" id="bullet"></button>
    <UncontrolledTooltip placement="bottom" target="bullet">
      Bullet list
    </UncontrolledTooltip>
    <select class="ql-align">
      <option selected></option>
      <option value="center"></option>
      <option value="right"></option>
      <option value="justify"></option>
    </select>
    <select className="ql-color">
      <option value="red"></option>
      <option value="green"></option>
      <option value="blue"></option>
      <option value="orange"></option>
      <option value="violet"></option>
      <option value="#d0d1d2"></option>
      <option selected></option>
    </select>
    <button className="ql-image" id="image"></button>
    <UncontrolledTooltip placement="bottom" target="image">
      Add image
    </UncontrolledTooltip>
    <button className="ql-link" id="link2"></button>
    <UncontrolledTooltip placement="bottom" target="link2">
      Hyperlink
    </UncontrolledTooltip>
    <button className="ql-blockquote" id="quote"></button>
    <UncontrolledTooltip placement="bottom" target="quote">
      Blockquote
    </UncontrolledTooltip>
    <button className="ql-clean" id="clean"></button>
    <UncontrolledTooltip placement="bottom" target="clean">
      Remove formatting
    </UncontrolledTooltip>
      <select className="ql-insertCustomTags">
      <option value="@model.BPNAME"></option>
      <option value="@model.BPNUMBER"></option>
      <option value="@model.BPCNUMBER"></option>
      <option value="@model.BPSNUMBER"></option>
      <option value="@model.Company"></option>
      <option value="@model.Currency"></option>
      <option value="@model.Description"></option>
      <option value="@model.DocumentID"></option>
      <option value="@model.DocumentType"></option>
      <option value="@model.OrderRef"></option>
      <option value="@model.Pages"></option>
      <option value="@model.TransactionDate"></option>
      <option value="@model.TransactionNumber"></option>
      <option value="@model.TransactionType"></option>
      <option value="@model.TransactionValue"></option>
      <option value="@model.UserName"></option>
      
      {customFields}
      <option selected></option>
    </select>

    <button onClick={onClickHtml} id="htmlButton" className="ql-inscribe">
      <CustomHtmlButton />
    </button>
    <UncontrolledTooltip placement="bottom" target="htmlButton">
      Switch text view
    </UncontrolledTooltip>
    <button onClick={onClickSagePay} className="ql-insertPayItNow" id="payitnow">
      <CustomSagePayButton />
    </button>
    <UncontrolledTooltip placement="bottom" target="payitnow">
      Add pay it now link
    </UncontrolledTooltip>
    <button onClick={onClickParameterURL} className="ql-insertParamertisedURL" id="hyperlink">
      <CustomURLButton />
    </button>
    <UncontrolledTooltip placement="bottom" target="hyperlink">
      Create custom hyperlink
    </UncontrolledTooltip>
  </div>
)

/*
 * Editor component with custom toolbar and content containers
 */
class Editor extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      style: '',
      editorHtml: '',
      rawHtml: '',
      text: false,
      toolbar: {},
      popoverURLAncor: null,
      popoverDeleteAncor: null,
      popoverAncor: null,
      filteredTemplates: [],
      selectedTabIndex: 0,
      editTemplateNameId: null,
      editTemplateNameText: '',
      erroredFields: [],
      paramURL: '',
      paramURLName: ''
    }

    this.quill = null;
  }

  handleChange = (html) => {
    //we need to update the html value of the current selected template
    let templates = JSON.parse(JSON.stringify(this.state.filteredTemplates));

    templates[this.state.selectedTabIndex].html = html;

    this.setState({
      editorHtml: html,
      filteredTemplates: templates
    })
  }

  handleRawChange = (html) => {
    //we need to update the html value of the current selected template
    let templates = JSON.parse(JSON.stringify(this.state.filteredTemplates));

    templates[this.state.selectedTabIndex].html = html;

    this.setState({
      rawHtml: html,
      filteredTemplates: templates
    })
  }

  handleEditTemplateNameChange = (e) => {
    this.setState({
      editTemplateNameText: e.target.value
    })
  }

  handleFilterTextChange = (filter) => {
    this.state.filteredTemplates[this.state.selectedTabIndex].filter = filter;
  }

  componentDidMount = () => {
    // Deep clone props to avoid mutation
    let templates = JSON.parse(JSON.stringify(this.props.filteredTemplates || []));
  
    // Ensure at least one template exists
    if (templates.length === 0) {
      templates.push({
        Name: 'Default',
        subject: '',
        html: '',
        placeholder: 'Enter email text ...',
        filter: {
          groupName: 'and',
          items: [] 
        },
        rawMode: false,
        valid: true
      });
    }
  
    templates.forEach(t => {
      if (!t.filter || !Array.isArray(t.filter.items)) {
        t.filter = {
          groupName: 'and',
          items: []
        };
      }
    });
  
    // Extract editor mode & content
    const selectedTemplate = templates[0];
    const rawMode = selectedTemplate.rawMode || false;
    const html = selectedTemplate.editorHtml || selectedTemplate.html || '';
    const rawHtml = selectedTemplate.rawHtml || selectedTemplate.html || '';
  
    this.setState({
      filteredTemplates: templates,
      text: rawMode,
      editorHtml: html,
      rawHtml: rawHtml
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    // need to update this method to support filters
    if (this.state.text !== prevState.text) {
      if (this.state.text) {
        this.state.filteredTemplates[this.state.selectedTabIndex].rawMode = true;
        this.props.updateTemplates(this.state.filteredTemplates, this.state.selectedTabIndex);

        this.setState({
          rawHtml: this.state.editorHtml
        })
      }
      else {
        this.state.filteredTemplates[this.state.selectedTabIndex].rawMode = false;
        this.props.updateTemplates(this.state.filteredTemplates, this.state.selectedTabIndex);

        this.setState({
          editorHtml: this.state.rawHtml
        })
      }
    }

    // check that filteredTemplates is defined before using
    if (this.props.filteredTemplates && this.state.filteredTemplates !== prevState.filteredTemplates) {
      //now that the state has been updated, send it up to the calling code to update its state as well.
      //therefore when we save this off in the correct state      
      this.props.updateTemplates(this.state.filteredTemplates, this.state.selectedTabIndex);
    }

    if (this.state.selectedTabIndex !== prevState.selectedTabIndex) {
      // fix to support legacy version for templates
      let template = this.state.filteredTemplates[this.state.selectedTabIndex];
      let html = '';
      let rawhtml = '';

      if (template.editorHtml) {
        html = template.editorHtml
      }
      else if (template.rawHtml) {
        rawhtml = template.rawHtml
      } else {
        html = template.html;
        rawhtml = template.html;
      }

      this.setState({
        editorHtml: html,
        rawHtml: rawhtml
      })

      this.props.updateTemplates(this.state.filteredTemplates, this.state.selectedTabIndex);
    }
  }

  activateHtmlButton = (e) => {
    let popoverAncor = null;
    let text = this.state.text;

    if (this.state.filteredTemplates[this.state.selectedTabIndex].rawMode) {
      popoverAncor = e.currentTarget;
    } else {
      text = !this.state.text
    }

    this.setState({
      text,
      popoverAncor
    })
  }

  activateParamURLButton = (e, t) => {
    this.setState({
      popoverURLAncor: e.currentTarget
    })
  }

  activateTemplateDeleteButton = (e, i) => {
    this.setState({
      popoverDeleteAncor: e.currentTarget,
      templateIdToDelete: i
    })
  }

  setParamURL = (value) => {
    this.setState({
      paramURL: value
    })
  }

  setParamURLName = (value) => {
    this.setState({
      paramURLName: value
    })
  }

  //add another filtered template and set it as the active one.
  addFilter = (e) => {
    this.setState(state => {
      const filteredTemplates = state.filteredTemplates.concat({
        Name: 'Template ' + (state.filteredTemplates.length + 1),
        subject: '',
        html: '',
        placeholder: 'Enter email text ....',
        filter: generateDefaultFilter(this.props.reportFields),
        rawMode: false,
        valid: true
      });

      const selectedTabIndex = state.selectedTabIndex + 1;
      const text = false;
      return {
        filteredTemplates,
        selectedTabIndex,
        text,
        editorHtml: '',
        rawHtml: ''
      };
    });
  };


  //remove the active template and set the previous one to be active
  //note that we need to make sure that we have at least one default.
  //so if this is the default one then we need to prevent it from being 
  //removed.
  removeFilter = () => {
    var i = this.state.templateIdToDelete;

    if (!i || i === 0) {
      return;
    }
    this.setState(state => {
      const filteredTemplates = state.filteredTemplates.filter((item, j) => i !== j);
      const selectedTabIndex = state.selectedTabIndex - 1;

      return {
        filteredTemplates,
        selectedTabIndex,
        popoverDeleteAncor: null
      }
    });

    this.props.deleteTemplate(i);
  };

  onClickTemplate = (index) => {
    let rawMode = false;

    if (this.state.filteredTemplates[index].rawMode)
      rawMode = true

    this.setState({
      selectedTabIndex: index,
      text: rawMode
    })
  }

  handlePopoverConfirm = () => {
    this.setState({
      text: !this.state.text,
      popoverAncor: null
    })
  };

  handlePopoverClose = () => {
    this.setState({
      popoverAncor: null
    })
  };

  handlePopoverURLClose = () => {
    this.setState({
      popoverURLAncor: null
    })
  };

  handlePopoverURLConfirm = (url) => {
    insertParamertisedURL(url);
    this.handlePopoverURLClose();
  }

  handlePopoverDeleteClose = () => {
    this.setState({
      popoverDeleteAncor: null
    })
  }

  handleSelectedIndexChange = (selectedTabIndex) => {
    if (this.state.selectedTabIndex !== selectedTabIndex)
      this.setState({ selectedTabIndex })
  }

  onClickEditTemplateName = (open, index) => {

    if (open)
      this.setState({
        editTemplateNameText: this.state.filteredTemplates[index].Name,
        editTemplateNameId: index
      })
    else {
      let filteredTemplates = this.state.filteredTemplates;
      filteredTemplates[index].Name = this.state.editTemplateNameText;

      this.setState({
        filteredTemplates: filteredTemplates,
        editTemplateNameText: '',
        editTemplateNameId: null
      })
    }
  }

  generateStylesDynamically = () => {
    let styles = "";
  
    for (const [key, label] of Object.entries(defaultFieldDescriptions)) {
      styles += `
        .ql-picker.ql-insertCustomTags [data-value="@model.${key}"]::before {
          content: "${label}"
        }
      `;
    }
  
    styles += `
      .ql-picker.ql-insertCustomTags .ql-picker-label::before {
        content: 'Fields'
      }
    `;
  
    if (this.props.customDescriptions) {
      styles += ' ' + this.props.customDescriptions.sort().join(' ');
    }
  
    return styles;
  };
  
  render() {
    let textarea = <div />;
    let customFields = [];
    let fields = [];
    
    const deduped = new Map();
    
    if (this.props.reportFields) {
      this.props.reportFields.forEach(reportField => {
        const fieldName = reportField?.Name?.trim();
        const key = fieldName?.toLowerCase();
    
        if (!fieldName || deduped.has(key)) return;
    
        deduped.set(key, {
          name: fieldName,
          caption: fieldName,
          operators: defaultOperators
        });
    
        customFields.push(
          <option key={fieldName} value={`@model.DocumentData.${fieldName}`} />
        );
      });
    }
    
    if (typeof defaultFieldDescriptions === 'object') {
      for (const [fieldName, label] of Object.entries(defaultFieldDescriptions)) {
        const key = fieldName?.toLowerCase();
        if (!key || deduped.has(key)) continue;
    
        deduped.set(key, {
          name: fieldName,
          caption: label,
          operators: defaultOperators
        });
      }
    } else {
      console.warn("defaultFieldDescriptions is not defined or not an object!");
    }
    
    fields = Array.from(deduped.values());
    
    let groups = [
      { caption: 'And', name: 'and' },
      { caption: 'Or', name: 'or' }
    ];
    let tabs = [];
    let tabContent = [];
    let popover = <div />;

    if (this.state.popoverURLAncor)
      popover = <QuillParameterUrlPopover
        popoverURLAncor={this.state.popoverURLAncor}
        handlePopoverURLClose={this.handlePopoverURLClose}
        handlePopoverConfirm={this.handlePopoverURLConfirm}
        paramURL={this.state.paramURL}
        setParamURL={this.setParamURL}
        setParamURLName={this.setParamURLName}
        paramURLName={this.state.paramURLName}
        options={this.props.reportFields}
      />

    if (this.state.popoverDeleteAncor)
      popover = <TemplateDeleteConfirmPopover
        popoverURLAncor={this.state.popoverDeleteAncor}
        handlePopoverConfirm={this.removeFilter}
        toggle={this.handlePopoverDeleteClose}
      />

    if (this.state.popoverAncor)
      popover = <Popover
        id={this.state.popoverAncor && 'simple-popover'}
        open={this.state.popoverAncor}
        anchorEl={this.state.popoverAncor}
        onClose={this.handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div style={{ padding: 20 }}>
          <p style={{ fontSize: '.9rem' }}>This will re-render and potentially change the html code, are you sure?</p>
          <ButtonGroup style={{ marginTop: 20 }}>
            <Button color="primary" onClick={this.handlePopoverConfirm}>
              Yes
            </Button>
            <Button color="secondary" onClick={this.handlePopoverClose}>
              Cancel
            </Button>
          </ButtonGroup>
        </div>
      </Popover>

    this.state.filteredTemplates.forEach((template, i) => {
      if (tabs.length === 0) {
        tabs.push(<Tab onClick={() => this.onClickTemplate(i)}> <Form inline><label>Default</label></Form> </Tab>);
      }
      else {
        tabs.push(
          <>
            {this.state.selectedTabIndex == i ?
              <Tab>
                <Form inline>
                  {this.state.editTemplateNameId == i ?
                    <Input type="text" style={{ height: '25px' }} defaultValue={template.Name} onChange={this.handleEditTemplateNameChange} />
                    :
                    <label>
                      {template.Name}
                    </label>
                  }
                  <>
                    {this.state.editTemplateNameId == i ?
                      <CheckIcon style={{ fontSize: '0.8rem', marginLeft: '10px', marginRight: '5px' }} onClick={() => this.onClickEditTemplateName(false, i)} />
                      :
                      <>
                        <EditIcon style={{ fontSize: '0.8rem', marginLeft: '10px', marginRight: '5px' }} onClick={() => this.onClickEditTemplateName(true, i)} />
                        <CloseIcon style={{ fontSize: '0.8rem' }} onClick={(e) => this.activateTemplateDeleteButton(e, i)} />
                      </>
                    }
                  </>
                </Form>
              </Tab>
              :
              <Tab onClick={() => this.onClickTemplate(i)}>
                <Form inline>
                  {this.state.editTemplateNameId == i ?
                    <Input type="text" style={{ height: '25px' }} defaultValue={template.Name} onChange={this.handleEditTemplateNameChange} />
                    :
                    <label>
                      {template.Name}
                    </label>
                  }
                </Form>
              </Tab>
            }
          </>
        );
      }

      // populate tab content section
      if (this.state.text)
        textarea = <Input id="html" className="html-input" type="textarea" value={this.state.rawHtml} onChange={(e) => this.handleRawChange(e.target.value)} />

      if (tabContent.length === 0) {
        tabContent.push
          (
            <TabPanel>
              <CustomToolbar onClickHtml={this.activateHtmlButton} onClickParameterURL={this.activateParamURLButton} onClickAddFilter={this.addFilter} onClickAddRemoveFilter={() => this.removeFilter(this.state.selectedTabIndex)} customFields={customFields} />
              {textarea}
              <div className={this.state.text ? "quill-hidden" : ""} >
                <ReactQuill
                  ref={(el) => this.quill = el}
                  value={this.state.editorHtml}
                  onChange={this.handleChange}
                  placeholder={this.props.placeholder}
                  modules={{
                    toolbar: {
                      container: "#toolbar",
                      handlers: {
                        "insertCustomTags": insertCustomTags,
                        "insertPayItNow": insertPayItNow,
                        "insertParamertisedURL": insertParamertisedURL,
                      }
                    },
                    ImageResize: {
                      modules: ['Resize', 'DisplaySize']
                    },
                  }}
                />
              </div>
            </TabPanel>
          );
      }
      else {
        tabContent.push
          (
            <TabPanel>
              {!template.valid ?
                <>
                  <Alert color="danger">
                    This template is no longer valid due to a missing metadata field, please re-add the field to resolve the issue
                  </Alert>
                  <FilterControl filterValue={template.filter || { groupName: 'and', items: [] }} fields={fields} onFilterValueChanged={this.handleFilterTextChange} />
                </>
                :
                <FilterControl filterValue={template.filter || { groupName: "and", items: [] }} fields={fields} onFilterValueChanged={this.handleFilterTextChange} />
              }
              <CustomToolbar onClickHtml={this.activateHtmlButton} onClickParameterURL={this.activateParamURLButton} onClickAddFilter={this.addFilter} onClickAddRemoveFilter={() => this.removeFilter(this.state.selectedTabIndex)} customFields={customFields} />
              {textarea}
              <div className={this.state.text ? "quill-hidden" : ""} >
                <ReactQuill
                  ref={this.quill}
                  value={this.state.editorHtml}
                  onChange={this.handleChange}
                  placeholder={this.props.placeholder}
                  modules={{
                    toolbar: {
                      container: "#toolbar",
                      handlers: {
                        "insertCustomTags": insertCustomTags,
                        "insertPayItNow": insertPayItNow,
                        "insertParamertisedURL": insertParamertisedURL,
                      }
                    },
                    ImageResize: {
                      modules: ['Resize', 'DisplaySize']
                    }
                  }
                  }
                />
              </div>
            </TabPanel>
          );
      }
    });
    // add new tab button
    tabs.push(<Tab onClick={this.addFilter} style={{ float: 'right' }}><span className="inscribe s-fonticon-btn" ></span></Tab>);

    return (
      <div className="text-editor" style={{ width: '100%' }}>
        <style dangerouslySetInnerHTML={{ __html: this.generateStylesDynamically() }} />
        <Tabs selectedIndex={this.state.selectedTabIndex} onSelect={this.handleSelectedIndexChange}>
          <TabList>
            {tabs}
          </TabList>
          {tabContent}
        </Tabs>
        {popover}
      </div>
    )
  }
}

export default Editor